import { useEffect, useState } from "react";
import { api } from "@/client/lib/api";
import { AdminPageHeader } from "@/client/components/admin/AdminPageHeader";
import { Button } from "@/client/components/ui/button";

export function NotificationsPage() {
  const [notifications, setNotifications] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const res = await api.api.notifications.$get();
        if (res.ok) {
          const data = await res.json();
          setNotifications(data.notifications);
        }
      } catch {
        // handle error
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  async function markAllRead() {
    try {
      await api.api.notifications["read-all"].$post();
      setNotifications((prev) => prev.map((n) => ({ ...n, readAt: new Date().toISOString() })));
    } catch {
      // handle error
    }
  }

  async function markRead(notificationId: number) {
    try {
      await (api.api.notifications as any)[":id"].read.$post({
        param: { id: String(notificationId) },
      });
      setNotifications((prev) =>
        prev.map((n) =>
          n.notificationId === notificationId ? { ...n, readAt: new Date().toISOString() } : n
        )
      );
    } catch {
      // handle error
    }
  }

  if (loading) {
    return <p className="text-muted-foreground">Laden...</p>;
  }

  const unreadCount = notifications.filter((n) => !n.readAt).length;

  return (
    <div className="space-y-6">
      <AdminPageHeader
        items={[{ label: "Meldingen" }]}
        subtitle={unreadCount > 0 ? `${unreadCount} ongelezen` : "Alles gelezen"}
        action={
          unreadCount > 0 ? (
            <Button variant="outline" size="sm" onClick={markAllRead}>
              Alles gelezen
            </Button>
          ) : undefined
        }
      />

      <div className="space-y-2">
        {notifications.map((notif: any) => (
          <div
            key={notif.notificationId}
            className={`rounded-lg border p-4 ${!notif.readAt ? "bg-muted/30" : ""}`}
            onClick={() => !notif.readAt && markRead(notif.notificationId)}
            role={!notif.readAt ? "button" : undefined}
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className={`text-sm ${!notif.readAt ? "font-medium" : ""}`}>
                  {notif.subject}
                </p>
                {notif.body && (
                  <p className="mt-1 text-sm text-muted-foreground line-clamp-2">{notif.body}</p>
                )}
              </div>
              <span className="shrink-0 text-xs text-muted-foreground">
                {new Date(notif.createdAt).toLocaleString("nl-NL", { dateStyle: "short", timeStyle: "short" })}
              </span>
            </div>
          </div>
        ))}
        {notifications.length === 0 && (
          <p className="text-muted-foreground">Geen meldingen.</p>
        )}
      </div>
    </div>
  );
}
